// Testing mode configuration
// Set TESTING_MODE to true to bypass login for review/testing
// Set back to false to restore normal authentication
export const TESTING_MODE = false;

export const MOCK_FAMILY = {
  id: 'test-family-000',
  name: 'Test Family',
  created_by: 'test-user-000',
  invite_code: 'TEST123',
};

export const MOCK_USER = {
  id: 'test-user-000',
  email: 'test@rutini.app',
  aud: 'authenticated',
  role: 'authenticated',
  app_metadata: {},
  user_metadata: {},
  created_at: new Date().toISOString(),
} as any;

export const MOCK_MEMBERS = [
  {
    id: 'test-parent-001',
    family_id: 'test-family-000',
    name: 'Mom',
    role: 'parent' as const,
    points_balance: 0,
    has_pin: false,
    avatar_url: null,
    color: '#6366f1',
    calm_mode: false,
    user_id: 'test-user-000',
    avatar_emoji: '👩',
    avatar_bg_color: '#6366f1',
    header_color: null,
  },
  {
    id: 'test-kid-001',
    family_id: 'test-family-000',
    name: 'Ahmed',
    role: 'kid' as const,
    points_balance: 45,
    has_pin: false,
    avatar_url: null,
    color: '#ec4899',
    calm_mode: false,
    user_id: null,
    avatar_emoji: '👦',
    avatar_bg_color: '#ec4899',
    header_color: null,
  },
  {
    id: 'test-kid-002',
    family_id: 'test-family-000',
    name: 'Sara',
    role: 'kid' as const,
    points_balance: 32,
    has_pin: false,
    avatar_url: null,
    color: '#14b8a6',
    calm_mode: false,
    user_id: null,
    avatar_emoji: '👧',
    avatar_bg_color: '#14b8a6',
    header_color: null,
  },
];
